module.exports = __webpack_public_path__ + "static/media/view4.1df4b939.jpg";